export class SubscriptionSummary {
  id: number;
  name: string;
  description: string;
  monthlyPrice: number;
  yearlyPrice: number;
  isActive: string;
  isPackage: string;
  moduleNames: string;
}

export class SubscriptionList {
  subscriptionList: SubscriptionSummary[];
  totalRecords: number;
}

export class GetSubscriptionListReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
}
